import axios from 'axios';
import {BASE_URL} from '../constants/constants';

let api = axios.create({
  baseURL: BASE_URL,
  responseType: 'json',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');

  if (token && config.headers) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.toJSON().message === 'Network Error') {
      return Promise.reject({
        status: 'network_error',
        message: 'No internet connection',
      });
    }
    const {data, status} = error.response;
    let response = {status, message: data?.message || data.error};
    if (status === 400) {
      response.message = data;
    } else if (status === 409) {
      console.log('API Error Response:', data);
    
      if (data && typeof data.message === 'string') {
        const message = data.message.split(' | ');
        const responseMessage = {};
        responseMessage[message[0]] = message[1];
        response.message = responseMessage;
      } else {
        console.error("Missing or invalid 'data.message'. Using fallback message.");
        response.message = { error: 'Resource already exits, conflict occuring' };
      }
    }
    return Promise.reject(response);
  },
);

export default api;
